<script lang="ts">
    import PlayButton from '@amp/web-app-components/src/components/buttons/PlayButton/PlayButton.svelte';
    import { getJetPerform } from '~/jet';
    import { PLAY_STATES } from '@amp/web-app-components/src/constants';
    import type { PlayIconSet } from '@amp/web-app-components/src/components/buttons/PlayButton/constants';
    import type { Action } from '~/jet/models';

    /**
     * Jet play action to use.
     * @type {Action}
     */
    export let playAction: Action;

    /**
     * Accessibility text for play button
     * @type {string}
     *
     */
    export let ariaLabel: string = '';

    /**
     * If it should render as a large play button
     * @type {boolean}
     */
    export let isLarge: boolean = false;

    /**
     * If it should render as an stand-alone play button
     * @type {boolean}
     */
    export let isStandAlone: boolean = false;

    /**
     * If it should render without hover state, filled in
     * @type {boolean}
     */
    export let isFilled: boolean = false;
    export let playButtonType: 'artworkHover' | null = null;
    export let isInChin: boolean = false;

    export let playButtonStyle: PlayIconSet = 'platter';

    const { PLAY } = PLAY_STATES;
    const perform = getJetPerform();
    const handleActionClick = () => perform(playAction);
</script>

<PlayButton
    iconState={PLAY}
    {ariaLabel}
    {isStandAlone}
    {isFilled}
    {playButtonType}
    {isInChin}
    iconSet={playButtonStyle}
    {isLarge}
    on:click={handleActionClick}
/>

<style lang="scss">
    *:global(.play-button) {
        --playButtonCircleHoverColor: var(--keyColor);
    }
</style>
